import type { ComponentDefinition, FormDocument } from '@formbird/types';
import { createSignal, onCleanup, For, Show } from 'solid-js';
import { Subscription } from 'rxjs';

const VALIDATE_FORM_FIELDS = 'document:validateFormFields';

interface ValidationDisplayProps {
  document: FormDocument;
  componentDefinition: ComponentDefinition;
}

export function ValidationDisplay(props: ValidationDisplayProps) {
  const validationService = (globalThis as any).FormbirdServiceInjector.get('ValidationService');
  const broadcastService = (globalThis as any).FormbirdServiceInjector.get('BroadcastService');

  const fieldName = props.componentDefinition.name;
  const documentId = props.document.documentId;

  const validators: { name: string; text: string }[] = validationService.loadValidators(
    props.componentDefinition,
    fieldName
  );
  const validatorValue = validationService.validationCtrlValues;

  const [tick, setTick] = createSignal(0);

  const subs = new Subscription();
  const sub = broadcastService.on(VALIDATE_FORM_FIELDS).subscribe((value: any) => {
    if (value && value.documentId === documentId && value.fieldName === fieldName) {
      setTick(t => t + 1);
    }
  });
  subs.add(sub);

  onCleanup(() => subs.unsubscribe());

  const isInvalid = (validatorName: string) => {
    tick(); // depend on tick so this re-evaluates when a validation event fires
    if (!documentId || !fieldName) return false;
    return validatorValue[documentId]?.[fieldName]?.[validatorName] === true;
  };

  return (
    <For each={validators}>
      {(validator) => (
        <Show when={isInvalid(validator.name)}>
          <div class="ft-validator">
            <span class="ft-validator-error" role="alert">{validator.text}</span>
          </div>
        </Show>
      )}
    </For>
  );
}
